import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import axios from "axios";
import {PopupMessage} from "../../utils/message";
import {Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography} from "@mui/material";
import {LoadingIndicator} from "../../components/LoadingIndicator";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export class SapphireCheatedUser extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            filter: {
                rubies: 1000,
                limit: 100,
                offset: 0,
            },
            users: [],
            userPurchases: {
                total: 0,
                purchases: []
            },
            selectedUserId: null,
            loading: false,
        }
    }

    componentDidMount() {
        this.fetchUsers();
    }

    async fetchUsers() {
        const url = `${Config.getInstance.apiUrl}/api/users/user_by_rubies`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const {filter} = this.state;

        const response = await axios.post(url, filter, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const users = data.users;
            this.setState({users});
        } else {
            PopupMessage.error("Fetch Data Failed");
        }
    }

    async fetchUserPurchases() {
        const userId = this.state.selectedUserId;
        const url = `${Config.getInstance.apiUrl}/api/users/user_purchases_info`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.setState({loading: true});

        const response = await axios.post(url, {userId}, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const {userPurchases} = this.state;
            const {total, purchases, ownerId} = data;

            if (ownerId !== userId) {
                return;
            }

            userPurchases.total = total;
            userPurchases.purchases = purchases;

            this.setState({userPurchases, loading: false});
        } else {
            PopupMessage.error("Fetch Data Failed");
        }
    }

    onChangeFilter(event, key) {
        const {filter} = this.state;
        const value = event.target.value;

        filter[key] = value;

        this.setState({filter});
    }

    onChangeSelectedUser(event, value) {
        if(this.state.loading) {
            return;
        }

        // Reset user purchases
        const {userPurchases} = this.state;
        userPurchases.total = 0;
        userPurchases.purchases = [];

        this.setState({selectedUserId: value, userPurchases, loading: true}, () => {
            this.fetchUserPurchases();
        });
    }

    formatNumber = (number) => {
        // format number from 1000 to 1,000
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    renderUserList = () => {
        const {users} = this.state;

        return <TableContainer component={Paper}>
            <Table className="min-table-size" >
                <TableHead>
                    <TableRow>
                        <TableCell>Uid</TableCell>
                        <TableCell>Username</TableCell>
                        <TableCell>Rubies</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users.map((user, index) => {
                        return <TableRow
                            key={index}
                            hover
                            onClick={(event) => this.onChangeSelectedUser(event, user.id)}
                            style={{
                                backgroundColor: this.state.selectedUserId === user.id ? '#00FFFF' : 'inherit',
                                cursor: "pointer"
                            }}
                        >
                            <TableCell style={{width: "30%"}}>{user.id}</TableCell>
                            <TableCell style={{width: "20%"}}>{user.name}</TableCell>
                            <TableCell style={{width: "30%"}}>{this.formatNumber(user.rubies)}</TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    }

    renderFilter = () => {
        const {filter} = this.state;

        return <Grid container spacing={2}>
            <Grid item container spacing={2}>
                <Grid item sm={3}>
                    <TextField
                        label="Rubies"
                        type="number"
                        value={filter.rubies}
                        onChange={(e) => this.onChangeFilter(e, 'rubies')}
                    />
                </Grid>

                <Grid item sm={3}>
                    <TextField
                        label="Offset"
                        type="number"
                        value={filter.offset}
                        onChange={(e) => this.onChangeFilter(e, 'offset')}
                    />
                </Grid>

                <Grid item sm={3}>
                    <TextField
                        label="Limit"
                        type="number"
                        value={filter.limit}
                        onChange={(e) => this.onChangeFilter(e, 'limit')}
                    />
                </Grid>
            </Grid>
            <Grid item justifyContent="flex-end" sm={12}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.fetchUsers()}
                    style={{float: "right", marginBottom: "20px", marginRight: "20px"}}
                >
                    Search
                </Button>
            </Grid>
        </Grid>
    }

    renderPurchases = () => {
        const user = this.state.users.find(user => user.id === this.state.selectedUserId);
        const {userPurchases} = this.state;

        if (!user) {
            return null;
        }

        let status = "CLEAN";

        let color = "#39ff14"


        if (userPurchases.total < user.rubies) {
            status = "SUSPICIOUS";
            color = "red"
        }

        // 'product_id', 'platform', 'have_error', 'transaction_id', 'created_at', 'device_id'

        return <TableContainer component={Paper}>
            <Typography variant="h5">Purchase Summary</Typography>
            <Typography variant="h6">{`Uid: ${user.id}`}</Typography>
            <Typography variant="h6">{`Name: ${user.name}`}</Typography>
            <Typography variant="h6">{`Current Rubies: ${this.formatNumber(user.rubies)}`}</Typography>
            <Typography variant="h6">{`Purchased Rubies: ${this.formatNumber(userPurchases.total)}`}</Typography>
            <Typography variant="h6">{`Status: `}<span style={{color}}>{`${status}`}</span></Typography>
            <Typography variant="h6">
                {`Copy Purchase Info: `}
                <ContentCopyIcon
                    onClick={() => this.copyToClipboard(JSON.stringify(userPurchases.purchases))}
                />
            </Typography>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Product Id</TableCell>
                        <TableCell>Platform</TableCell>
                        <TableCell>Transaction Id</TableCell>
                        <TableCell>Device Id</TableCell>
                        <TableCell>Created At</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {userPurchases.purchases.map((purchase, index) => {
                        return <TableRow key={index}>
                            <TableCell>{purchase.product_id}</TableCell>
                            <TableCell>{purchase.platform}</TableCell>
                            <TableCell>{purchase.transaction_id}</TableCell>
                            <TableCell>{purchase.device_id}</TableCell>
                            <TableCell>{purchase.created_at}</TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>

        </TableContainer>
    }

    render() {
        return (
            <div className="contentPadding" style={{width: "100%"}}>
                <div>
                    <Paper className="root" elevation={0}>
                        <Typography variant="h2" fontWeight="bold" style={{marginBottom: '50px'}}>
                            Suspicious Users (Sapphire Purchase)
                        </Typography>
                        {this.renderFilter()}
                        <Grid container sm={12} spacing={2}>
                            <Grid item sm={5}>
                                {this.renderUserList()}
                            </Grid>
                            <Grid item sm={7}>
                                {
                                    this.state.loading ?
                                        <LoadingIndicator classes loadingTextPlaceholder="Getting Data" loadingText={true} />
                                        : this.renderPurchases()
                                }

                            </Grid>

                        </Grid>

                    </Paper>
                </div>
            </div>
        );
    }
}